import { ColumnElement, DreamBlock } from '@typedream/core';
import { TRenderElementProps } from '@udecode/plate-core';
import { ComponentType } from 'react';
import { createTElementPluginFactory } from '../../plate';
import { ELEMENT_COLUMN, ELEMENT_COLUMN_ITEM } from '../../pluginKeys';
import { withDropTarget } from '../../plugins/dnd';
import { ColumnElementEditor } from './components/ColumnElement';
import { createColumnItemPlugin } from './createColumnItemPlugin';
import { getDefaultColumnValue } from './defaults';
import { withColumn } from './withColumn';

export const createColumnPlugin = createTElementPluginFactory({
  key: ELEMENT_COLUMN,
  component: withDropTarget(ColumnElementEditor as ComponentType<TRenderElementProps>),
  options: {
    isDreamBlock: true,
    isSelectable: true,
    isResizable: (element: DreamBlock) => {
      const directions: Array<'s' | 'w' | 'e'> = ['w', 'e'];
      if ((element as ColumnElement).height) {
        directions.push('s');
      }
      return { directions };
    },
    isDraggable: true,
    isDroppable: true,
    meta: {
      img: '/canvas/images/columns.png',
      title: 'Columns',
      subtitle: 'Make 2 or more columns',
      keywords: ['section', 'columns', 'box', 'block'],
    },
    format: {
      formatType: 'block',
      insertNode: getDefaultColumnValue() as unknown as DreamBlock,
      turnInto: [],
      focusableWhenEmpty: false,
      validProperties: [
        'height',
        'width',
        'width_max',
        'align',
        'vertical_align',
        'mobile_direction',
        'mobile_reverse_columns',
        'mobile_horizontal_overflow',
        'background',
        'backgroundImage',
        'backgroundDarken',
        'mobile_hide',
        'desktop_hide',
        'padding',
        'gap',
        'margin',
        'border_radius',
        'box_shadow',
      ],
      validChildrenTypes: [ELEMENT_COLUMN_ITEM],
    },
  },
  withOverrides: withColumn,
  plugins: [createColumnItemPlugin()],
});
